import { useMutation } from "@apollo/react-hooks";
import { Button, Form, Input, message, Typography } from "antd";
import React from "react";
import { useHistory } from "react-router";
import ResetPasswordImage from "../../../Assets/Images/009.jpg";
import { RESET_PASSWORD } from "../../../Graphql/mutations";

const { Title } = Typography;

export const ResetPasswordPage = () => {
  const user_id = localStorage.getItem("user_id");

  const history = useHistory();

  const [RESET_PASSWORD_MUTATION, { loading: passwordResting }] = useMutation(
    RESET_PASSWORD
  );

  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };
  const tailLayout = {
    wrapperCol: {
      span: 24,
    },
  };

  const onFinish = async (values) => {
    try {
      const response = await RESET_PASSWORD_MUTATION({
        variables: {
          user_id,
          password: values?.confirm,
        },
      });
      if (response.data.reset_user_password.status === "OK") {
        history.push("/on-boarding/confirm-details");
        message.success(response.data.reset_user_password.message);
      } else {
        message.error(response.data.reset_user_password.message);
      }
    } catch (err) {
      message.error("Could not reset password!");
    }
  };

  return (
    <div className="rowSec">
      <div className="colSec onBoardingLeft">
        <img src={ResetPasswordImage} alt="" className="" />
      </div>
      <div className="colSec onBoardingRight">
        <div className="login">
          <Title level={2}>Reset Account Password</Title>
          <p className="subTitle">
            Your identity has been verified, set your new password
          </p>
          <Form {...layout} name="basic" onFinish={onFinish}>
            <Form.Item
              name="password"
              label="Enter New Password"
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                  whitespace: true,
                },
                {
                  pattern: new RegExp(
                    "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-+.,|_~`'\"]).{6,}$"
                  ),
                  message:
                    "Minimum 6 characters at least 1 Uppercase Alphabet, 1 Lowercase Alphabet, 1 Number and 1 Special Character!",
                },
              ]}
              hasFeedback
            >
              <Input.Password placeholder="Enter New Password" />
            </Form.Item>
            <Form.Item
              name="confirm"
              label="Confirm Password"
              dependencies={["password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please confirm your password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "The two passwords that you entered do not match!"
                      )
                    );
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Confirm Password" />
            </Form.Item>
            <Form.Item {...tailLayout} className="buttonSec">
              <Button
                loading={passwordResting}
                type="primary"
                shape="round"
                size="large"
                htmlType="submit"
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};
